import React from 'react';

export default ({options, valueInOptionText}) => {
    return (
        <React.Fragment>
            {
                options.map(item =>
                    <option value={item.value} key={item.value}>
                        { valueInOptionText ? item.value + " - " + item.text : item.text}
                    </option>
                )
            }
        </React.Fragment>
    )
};